<template>
  <div>
    <img :src="footerInfo.LegalPerson" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      footerInfo: {}
    }
  },

  created() {
    this.getFooterInfo()
  },

  methods: {
    // 底部信息
    async getFooterInfo() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetSX_CompanyList'
      )
      this.footerInfo = res.data
    }
  }
}
</script>

<style scoped>
div {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 767px) {
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
}
</style>
